// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1xxgP","labelText":"styles_labelText__1VoLZ"};